module.exports = __webpack_public_path__ + "img/en_backgroundImg.3dff2721.jpg";